import i18n from 'i18next';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common');

const MAX_LENGTH = 20;

export const schema = yup.object({
  name: yup.string().required(t('employers.grid.errors.name_required')),
  nameBrief: yup
    .string()
    .label(t('employers.grid.nameBrief'))
    .max(MAX_LENGTH, ({ label }) =>
      t('validationMaxCharacters', {
        name: `${label}`,
        number: `${MAX_LENGTH}`
      })
    )
    .required(t('employers.grid.errors.name_brief_required'))
});
